import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle, Sparkles, ArrowRight } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

interface WelcomeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  userName?: string;
}

export const WelcomeDialog = ({ isOpen, onClose, userName }: WelcomeDialogProps) => {
  const { showAuthModal } = useAuth();

  const handleGetStarted = () => {
    onClose();
    // Öffne das Anmelde-Modal
    showAuthModal('login');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-8 h-8 text-emerald-600" />
          </div>
          <DialogTitle className="text-center text-2xl font-bold text-emerald-900">
            Willkommen bei KaufPause! 🎉
          </DialogTitle>
          <DialogDescription className="text-center">
            {userName ? `Hallo ${userName}! ` : 'Hallo! '}
            Deine E-Mail-Adresse wurde erfolgreich bestätigt.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-200">
            <h3 className="font-medium text-emerald-800 mb-2 flex items-center gap-2">
              <Sparkles className="w-4 h-4" />
              Dein Konto ist jetzt aktiv!
            </h3>
            <p className="text-emerald-700 text-sm">
              Du kannst dich jetzt anmelden und mit KaufPause beginnen, deine Impulskäufe zu kontrollieren.
            </p>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h4 className="font-medium text-blue-800 mb-2">Nächste Schritte:</h4>
            <ul className="text-blue-700 text-sm space-y-1">
              <li>• Melde dich mit deinen Zugangsdaten an</li>
              <li>• Füge dein erstes Produkt zur Warteliste hinzu</li>
              <li>• Starte deine 30-Tage Bedenkzeit</li>
            </ul>
          </div>

          <Button
            onClick={handleGetStarted}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white"
          >
            Jetzt anmelden
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}; 